import { NotificationsIcon } from '@mm/icons';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { Circle } from '@mm/components';
import { showSlideoutMenu } from '@mm/state/actions/viewActions';
import { useWhatsNewCRUDActions } from '@mm/state/actions/WhatsNewCRUDActions';
import { StoreState } from '@mm/state/store-interfaces';
import { colors } from '../../../editor/features/beta/styles/colors';
import { useWhatsNewItems } from '../../../editor/components/SlideoutMenu/menus/SlideoutWhatsNew/useWhatsNewItems';
import './WhatsNewLink.pcss';

export const WhatsNewLink = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  const handleClick = () => dispatch(showSlideoutMenu('whatsNew'));
  const { filteredItems, whatsNewItems } = useWhatsNewItems();
  const { retrieveAll } = useWhatsNewCRUDActions();

  useEffect(() => {
    if (!whatsNewItems?.length) {
      retrieveAll();
    }
  }, []);

  return (
    <div className="whats-new-link__beta" onClick={handleClick}>
      <NotificationsIcon />
      {!!filteredItems.length && (
        <Circle color={colors.red} className="whats-new-link__beta-badge" />
      )}
    </div>
  );
};
